import React from "react";
import "./About.css";
import { motion } from "framer-motion";
import { FaUser, FaBriefcase, FaCode, FaAward } from "react-icons/fa";
import { portfolioData } from "../../data/portfolioData";

const About = () => {
  const { about } = portfolioData;

  // Map icons to the corresponding stats indexes dynamically
  const icons = [<FaBriefcase />, FaBriefcase, <FaCode />, <FaAward />];

  return (
    <section className="about-section" id="about">
      <div className="about-container">
        
        {/* Left Typography Side */}
        <motion.div 
          className="about-content"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <span className="about-subtitle">{about.subtitle}</span>
          <h2 className="about-title">
            Building digital solutions <br />
            with <span className="text-gradient">passion</span> and <span className="text-gradient">purpose</span>.
          </h2>
          <p className="about-description">
            {about.description}
          </p>
          <a href="#contact" className="btn-about">
            More About Me <span className="arrow-icon">→</span>
          </a>
        </motion.div>

        {/* Right Metric Grid Side */}
        <div className="about-grid">
          {about.stats.map((stat, index) => (
            <motion.div 
              key={stat.id}
              className="about-stat-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="about-card-icon">
                {index === 0 && <FaBriefcase />}
                {index === 1 && <FaUser />}
                {index === 2 && <FaCode />}
                {index === 3 && <FaAward />}
              </div>
              <h3 className="about-card-value">{stat.value}</h3>
              <p className="about-card-label">{stat.label}</p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default About;